// src/config.js
export const API_URL = "https://e4ats.e4sspl.xyz";

export const google = {
  API_KEY: "",
  CLIENT_ID: "",
  SECRET: "",
};

export const facebook = {
  APP_ID: "",
};
